import React from 'react';
import { Button } from './ui/button';

const HeroSection = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-black">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-black via-purple-900/30 to-black"></div>

      {/* Content */}
      <div className="relative z-10 text-center text-white px-4">
        <div className="max-w-4xl mx-auto">
          {/* Logo */}
          <div className="mb-8">
            <img
              src="https://customer-assets.emergentagent.com/job_reality-bender/artifacts/es2mwale_logo1.png"
              alt="Simon Nomis Logo"
              className="w-64 md:w-80 lg:w-96 mx-auto"
            />
          </div>

          <p className="text-lg sm:text-2xl md:text-3xl mb-6 sm:mb-8 text-purple-300 font-bold max-w-2xl mx-auto drop-shadow-lg leading-tight sm:leading-normal" style={{textShadow: '2px 2px 0px black, -2px -2px 0px black, 2px -2px 0px black, -2px 2px 0px black'}}>
            Don't miss Florida's most acclaimed magic experience taking part in Orlando
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <a
              href="https://simonnomismagcentertainment.ticketspice.com/mental-hop-scotch"
              target="_blank"
              rel="noreferrer"
              className="bg-purple-600 hover:bg-purple-700 text-white px-8 py-4 text-lg rounded-full transition-all duration-300 transform hover:scale-105 hover:shadow-lg font-medium"
            >
              Get Tickets
            </a>
            <Button
              onClick={() => scrollToSection('show')}
              variant="outline"
              className="border-white text-white hover:bg-white hover:text-black px-8 py-4 text-lg rounded-full transition-all duration-300 transform hover:scale-105"
            >
              Watch Trailer
            </Button>
          </div>
        </div>

        {/* Scroll indicator */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
          <div className="w-6 h-10 border-2 border-white rounded-full flex justify-center">
            <div className="w-1 h-3 bg-white rounded-full mt-2 animate-pulse"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;